if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      if(this.querySelector('form')){
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }else {
        this.querySelector('[name=id]').disabled = false
         this.querySelector('button[type=submit]').addEventListener(
						'click',
						this.onSubmitHandler.bind(this)
					)
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
				formData.append('id', this.querySelector('[name=id]').value)
			}
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            if (typeof window.refreshCartDrawer === 'function') {
              window.refreshCartDrawer();
            }

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } 
          
          else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


window.refreshCartDrawer = async function () {
  try {
    const response = await fetch(window.location.href, {
      method: 'GET',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error(
        `Nie udało się pobrać koszyka. Status: ${response.status}`
      );
    }

    const html = await response.text();

    const parsedDocument = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const currentDrawer = document.querySelector('cart-drawer');
    const refreshedDrawer =
      parsedDocument.querySelector('cart-drawer');

    if (!currentDrawer || !refreshedDrawer) {
      throw new Error('Nie znaleziono elementu cart-drawer.');
    }

    const openClasses = ['active', 'is-open', 'open'];

    const activeOpenClasses = openClasses.filter((className) =>
      currentDrawer.classList.contains(className)
    );

    const wasOpen = activeOpenClasses.length > 0;

    const currentCartBubble =
      document.querySelector('#cart-icon-bubble');

    const refreshedCartBubble =
      parsedDocument.querySelector('#cart-icon-bubble');

    if (currentCartBubble && refreshedCartBubble) {
      currentCartBubble.replaceWith(refreshedCartBubble);
    }

    currentDrawer.replaceWith(refreshedDrawer);

    if (wasOpen) {
      requestAnimationFrame(() => {
        if (typeof refreshedDrawer.open === 'function') {
          const trigger =
            document.querySelector('#cart-icon-bubble');

          refreshedDrawer.open(trigger);
        } else {
          activeOpenClasses.forEach((className) => {
            refreshedDrawer.classList.add(className);
          });
        }
      });
    }
  } catch (error) {
    console.error('[Cart drawer refresh]', error);
  }
};